export default __webpack_public_path__ + "static/media/completeChallenge.0273b003.png";